module.exports = __webpack_public_path__ + "static/media/snapchat-square.64fb077e.svg";